$(function() {
    var accessibility = {
        thirdPartySuccessEvent: 'INDbuttonRevealed',
        selectors: {
            accessibilityButtonWrapper: '[data-accessibility-nav-icon]',
            openAccessibilityButton: '[data-explore-accessibility]',
            closeAccessibilityButton: '[data-close-accessibility]',
            thirdPartyOpenButton: '#INDmenu-btn',
            thirdPartyCloseButton: '#INDcloseAccMenu',
            thirdPartySwitchOffButton: '#INDswitchoffBtn',
            buttonTextIdentifier: '.INDmenuBtn-text',
            buttonDescriptionIdentifier: '.INDmenuBtn-desc'
        },
        registerEventListeners: function() {
            $('body')
                .on('click', accessibility.selectors.openAccessibilityButton, function() {
                    $(accessibility.selectors.thirdPartyOpenButton).trigger('click');
                })
                .on('click', accessibility.selectors.closeAccessibilityButton, function() {
                    $(accessibility.selectors.thirdPartyCloseButton).trigger('click');
                });

            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver,
                observeAccessibilityMenu = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName == 'class' && mutation.target.classList.contains('INDmenu-open')) {
                            $(accessibility.selectors.openAccessibilityButton).addClass('hidden');
                            $(accessibility.selectors.closeAccessibilityButton).removeClass('hidden');
                            accessibility.alterCopy();
                        } else {
                            $(accessibility.selectors.openAccessibilityButton).removeClass('hidden');
                            $(accessibility.selectors.closeAccessibilityButton).addClass('hidden');
                        }
                    });
                });

            observeAccessibilityMenu.observe(document.querySelector('body'), {
                attributes: true
            });

            $(accessibility.selectors.accessibilityButtonWrapper).removeClass('hidden');
        },
        alterCopy: function() {
            var $thirdPartySwitchOffButton = $(accessibility.selectors.thirdPartySwitchOffButton),
                $buttonText = $thirdPartySwitchOffButton.find(accessibility.selectors.buttonTextIdentifier),
                $buttonDescription = $thirdPartySwitchOffButton.find(accessibility.selectors.buttonDescriptionIdentifier);

            if ($buttonText.length && $buttonDescription.length) {
                $buttonText.text('Reset settings');
                $buttonDescription.text('Reset all accessibility settings');
            }
        },
        init: function() {
            if (document.querySelector(accessibility.selectors.thirdPartyOpenButton)) {
                accessibility.registerEventListeners();
                return false;
            }

            document.body.addEventListener(accessibility.thirdPartySuccessEvent, function() {
                accessibility.registerEventListeners();
            });
        },
    };

    accessibility.init();
});
